import DummyStorage from './dummyStorage';
import { DebugHelper } from './debugHelper';

/**
 * Cookie代わりのLocalStorage
 */
class MimicCookieHelper
{
    private storage: Storage;

    constructor(storage: Storage)
    {
        this.storage = storage;
    }

    public getItem(key: string): string | null
    {
        const value = this.storage.getItem(key);
        if (!value) {
            return null;
        }
        try {
            return JSON.parse(value);
        } catch (SyntaxError) {
            return null;
        }
    }

    public setItem(key: string, value: string): void
    {
        this.storage.setItem(key, JSON.stringify(value));
    }

    public removeItem(key: string): void
    {
        this.storage.removeItem(key);
    }

    public hasItem(key: string): boolean
    {
        return !!this.getItem(key);
    }

    public keys(): Array<string>
    {
        let list: Array<string> = [];
        const L = this.storage.length;
        for (let i = 0; i < L; i++)
        {
            list.push(this.storage.key(i) as string);
        }
        return list;
    }

    // 使ってない
    public checkEnabled(): boolean
    {
        return true;
    }
}

/**
 * Cookie版
 */
class RealCookieHelper{

    static getItem(sKey:string):any {
        if (!sKey || !this.hasItem(sKey)) { return null; }
        return JSON.parse(unescape(document.cookie.replace(new RegExp("(?:^|.*;\\s*)" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"), "$1")));
    }

    static setItem(sKey:string, sValue:any, vEnd?:any, sPath?:string, sDomain?:string, bSecure:boolean = false):void {

        sValue = JSON.stringify(sValue)

        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return; }
        var sExpires = "";
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? "; expires=Tue, 19 Jan 2038 03:14:07 GMT" : "; max-age=" + vEnd;
                    break;
                case String:
                    sExpires = "; expires=" + vEnd;
                    break;
                case Date:
                    sExpires = "; expires=" + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie = escape(sKey) + "=" + escape(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    }

    static removeItem(sKey:string, sPath?:string):void {
        if (!sKey || !this.hasItem(sKey)) { return; }
        document.cookie = escape(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sPath ? "; path=" + sPath : "");
    }
    static hasItem(sKey:string):boolean {
        return (new RegExp("(?:^|;\\s*)" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
    }

    static keys():string[] {
        var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
        for (var nIdx = 0; nIdx < aKeys.length; nIdx++) { aKeys[nIdx] = unescape(aKeys[nIdx]); }
        return aKeys;
    }

    static checkEnabled():boolean{
        var result:boolean = false;
        try{
            var propName:string = 'testEnabled';
            RealCookieHelper.setItem(propName, "test");
            result = !(RealCookieHelper.getItem(propName) === null);
            if(result){
                RealCookieHelper.removeItem(propName);
            }
        }catch(err){
            return false;
        }
        return result;
    }
}

let helper: any;
try {
    // ElectronからStorageを受け取っていなかったらLocalStorageを使う
    if ((window as any).configStorage) {
        helper = new MimicCookieHelper((window as any).configStorage);
    } else {
        helper = new MimicCookieHelper(localStorage);
    }
} catch (e) {
    DebugHelper.trace("Local Storage is blocked");
    // CookieやLocalStorageがブロックされている
    helper = new MimicCookieHelper(new DummyStorage);
}
export const CookieHelper = helper;
